// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.InputPasswordStrong_unCheck__1QbU1 {\n  color: #f05353; }\n  .InputPasswordStrong_unCheck__1QbU1 span {\n    color: #f05353; }\n\n.InputPasswordStrong_checked__2FdfF {\n  color: #0c9119; }\n  .InputPasswordStrong_checked__2FdfF span {\n    color: #0c9119; }\n\n.InputPasswordStrong_description__2OVJR {\n  position: relative;\n  top: -12px; }\n", ""]);
// Exports
exports.locals = {
	"unCheck": "InputPasswordStrong_unCheck__1QbU1",
	"checked": "InputPasswordStrong_checked__2FdfF",
	"description": "InputPasswordStrong_description__2OVJR"
};
module.exports = exports;
